import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/authenticated/services/user.service';
import { CardService } from 'src/app/authenticated/services/card.service';
import { Card } from '../../models/card-models/card';
import { DomSanitizer } from '@angular/platform-browser';
import { AemService } from '../../../_shared/services/aem-content.service';
import { ApiService } from 'src/app/_shared/services/api.service';

@Component({
  selector: 'business-footer',
  templateUrl: './business-footer.component.html',
  styleUrls: ['./business-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BusinessFooterComponent implements OnInit {
  @Input() isAuthenticated: boolean;
  footerContent: any;
  disclaimers: Array<string>;

  constructor(
    public dialog: MatDialog,
    private readonly userService: UserService,
    private readonly cardService: CardService,
    public router: Router,
    public location: Location,
    private domSanitizer: DomSanitizer,
    private aem: AemService,
    private readonly apiService: ApiService
  ) {}

  footerRouting = [
    { page: 'Dashboard', route: 'dashboard' },
    { page: 'Redeem', route: 'redeem-points' },
    { page: 'Vehicles', route: 'gmvehicles' }
  ];

  footerRoute: string = '';

  ngOnInit(): void {
    this.footerRoute = this.router.url;
    this.getFooterContent();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.footerRoute = event.urlAfterRedirects;
        this.getFooterContent();
      });
  }

  getFooterContent(): void {
    this.apiService.getAemPage('footer').subscribe(data => {
      this.footerContent = JSON.parse(data.footerContent);
      if (this.isAuthenticated) {
        this.disclaimers = this.footerContent.authenticatedFooter.disclaimers;
        if (this.footerRoute === '/dashboard') {
          this.disclaimers =
            this.footerContent.authenticatedFooter.dashboardDisclaimers;
        }
      } else {
        this.disclaimers = this.footerContent.marketingFooter.disclaimers;
      }
    });
  }
}
